import { createSelector } from 'reselect';
import { getWorkOrderOperationProgress } from './getWorkOrderOperationProgress';

/**
 * Parts produced attributable to the current work order operation, used as the
 * basis for material consumption (consumed = qtyPerUnit * partsProduced).
 *
 * This is the committed labor-ticket total, good + bad. Scrap consumes material
 * too (a part is counted, then kept or scrapped — the count and the material it
 * used do not change), and per ticket `goodParts + badParts` equals the
 * operator's entered `totalParts` (see useSubmitLaborTicket), so this reflects
 * every up/down count correction and after-the-fact ticket edit.
 *
 * Scoped to the current WOO via getWorkOrderOperationProgress. Picking only ever
 * runs for the current WOO, so the single shared selector is correct for both
 * the Materials Log display and the labor-form submission gate.
 */
export const getWooProducedParts = createSelector(
  [getWorkOrderOperationProgress],
  ({ workOrderOpTotalParts, workOrderOpBadParts }) => {
    return (workOrderOpTotalParts || 0) + (workOrderOpBadParts || 0);
  }
);
